__webpack_require__.p = "/wp-content/themes/badabimbi-theme/vue-app/dist/";